export const windowEventNames = {
  localNotificationStorageChanged: 'gp:local-notification-storage-changed',
} as const
